// extracted by mini-css-extract-plugin
export var breadcrumb = "_1p-0";
export var breadcrumbArrow = "_1p-1";